import React from "react"
import { Text } from "../../Atoms"
import { Input } from "../../Molecules"
function OraganismChangeSettingDetails(props) {
    return (
        <>
            <Text
                text={props.firstInputLabel}
                className={props.firstInputClassName}
            />
            {props.firstInputdiscription &&
                <Text
                    text={props.firstInputdiscription}
                    className={props.firstInputdiscriptionClassName}
                />
            }
            <Input
                classNameContainer={props.firstInputClassNameContainer}
                labelClassName={props.firstInputlabelClassName}
                className={props.errorMsg === '' || props.errorMsg === undefined ? "input-change-password setting-input__set-container" : "input-change-password setting-input__set-container setting-input__red-container"}
                placeholder=""
                value={props.firstInputValue}
                onChange={props.firstInputOnChange}
            />
            <Input
                inputLabel={props.SecondInputLabel}
                classNameContainer="container-confirme-password"
                labelClassName="setting-password-title mb-8"
                className={props.errorMsg === '' || props.errorMsg === undefined ? "input-change-password setting-input__set-container" : "input-change-password setting-input__set-container setting-input__red-container"}
                placeholder=""
                value={props.SecondInputValue}
                onChange={props.SecondInputOnChange}
                {...(props.errorMsg !== '' && { errorMsg: props.errorMsg })}
            />
        </>

    )
}
OraganismChangeSettingDetails.defaultProps = {
    firstInputText: "",
    firstInputClassName: "",
    firstInputdiscription: "",
    firstInputdiscriptionClassName: "",
    firstInputClassNameContainer: "",
    firstInputlabelClassName: "",
    SecondInputLabel: "",
}
export default OraganismChangeSettingDetails
